export const ASYNC_FETCH = 'ILD_Review/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_ILDREVIEWPAGE = 'ILD_Review/ASYNC_FETCH_SUCCESS_ILDREVIEWPAGE';
export const ASYNC_FETCH_FAILURE = 'ILD_Review/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ILD_Review/ASYNC_FETCH_INVALIDATE';
export const SET_REVIEW_DATA = 'ILD_Review/SET_REVIEW_DATA';
export const SET_ISREVIEW_LOAD = 'ILD_Review/SET_ISREVIEW_LOAD';
/**
 * action types
 * @type {string}
 */
